// extracted by mini-css-extract-plugin
export default {"stickyFooter":"stickyFooter_stickyFooter__aeYWD"};